export enum Ranks {
  S = "S",
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
}
